// courses/course_C04.ts

export const course_C04 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 아티스트 케어의 정의: "단순 심부름이 아닙니다"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">현장 케어는 아티스트가 오직 <strong style="color: #0284c7;">'예술 활동(연기, 노래 등)'</strong>에만 100% 집중할 수 있는 최적의 환경을 만드는 모든 활동을 말합니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>최상의 컨디션 유지:</strong> 덥거나 추운 환경, 배고픔, 피로도 등을 미리 파악하여 아티스트의 에너지가 떨어지지 않게 관리합니다.</li>
      <li><strong>심리적 안정감 제공:</strong> 긴장되는 촬영이나 생방송 직전, 아티스트가 흔들리지 않도록 곁에서 든든한 버팀목이 되어주는 역할입니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 현장에서의 올바른 소통법</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">아티스트는 감정이 예민해질 수 있는 직업입니다. 매니저의 말 한마디가 그날의 결과물을 바꿀 수 있습니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>'눈치'는 매니저의 제1역량:</strong> 아티스트가 지금 집중하고 있는지, 휴식이 필요한지 표정과 분위기만 보고도 빠르게 파악해야 합니다.</li>
      <li style="margin-bottom: 8px;"><strong>긍정적인 피드백:</strong> 불안해하는 아티스트에게는 "방금 너무 좋았습니다", "지금 컨디션 좋아 보여요" 같은 짧고 진심 어린 격려가 큰 힘이 됩니다.</li>
      <li><strong>전달은 명확하게:</strong> 스케줄 변동이나 스태프의 요청 사항을 전달할 때는 아티스트가 혼란스럽지 않게 결론부터 조용히, 정확하게 전달합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 현장 케어의 구체적인 실무 (체크리스트)</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">입문자가 현장에 도착하자마자 몸에 익혀야 할 기본 동작들입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>동선 확보:</strong> 차량에서 내려 대기실이나 촬영장까지 안전하게 이동할 수 있도록 길을 열어줍니다.</li>
      <li style="margin-bottom: 8px;"><strong>물품 준비:</strong> 아티스트가 마실 물(빨대 포함), 물티슈, 손거울, 대본, 계절에 맞는 방한용품(패딩)이나 냉방용품 등을 항상 손 닿는 곳에 둡니다.</li>
      <li><strong>주변 환경 관리:</strong> 대기실이 너무 시끄럽거나 외부인이 불쑥 들어오지 않도록 적절히 통제하여 아티스트의 프라이버시를 보호합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 매니저의 마음가짐: "내가 곧 아티스트의 얼굴이다"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">현장에서 매니저의 태도는 곧 그 아티스트의 이미지로 직결됩니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>겸손하되 당당하게:</strong> 스태프들에게는 항상 예의 바르게 인사하고 협조적인 태도를 보입니다. 하지만 아티스트의 권리가 부당하게 침해될 때는 회사와 상의하여 당당하게 요청해야 합니다.</li>
      <li><strong>인내심과 평정심:</strong> 현장은 대기 시간이 길고 변수가 많습니다. 매니저가 먼저 지치거나 짜증을 내면 아티스트는 더 크게 동요합니다. 어떤 상황에서도 침착함을 유지하는 것이 중요합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 현장 케어 기초 교육이 필요한가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>불필요한 마찰 방지:</strong> 아티스트와의 신뢰 관계는 현장에서의 작은 배려와 소통에서 시작됩니다. 기초가 없으면 사소한 실수로 큰 불신을 살 수 있습니다.</li>
      <li><strong>전문성 인정:</strong> 아티스트가 "이 매니저와 함께라면 든든하다"라고 느끼는 순간, 여러분은 단순 직원이 아닌 진정한 파트너로 인정받게 됩니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "최고의 케어는 아티스트가 매니저의 존재를 의식하지 않아도 될 만큼 모든 것이 완벽하게 준비되어 있는 상태를 만드는 것입니다."
    </p>
  </div>
`;
